import { createApp } from 'vue';
import Mp4ToWavConverter from '@/Components/Mp4ToWavConverter.vue';
import '@styles/app.css';

createApp(Mp4ToWavConverter).mount('#mp4-to-wav-converter');
